export default function StepBox({ icon, noteIcon, stepNum, heading, description, wavyArrow }) {
  return (
    <div className="step-box">
      <div className="step-icon">
        <div className="step-elm">
          <div className="step-elm-elm">
            {icon && <img src={icon} alt="no image" />}
            {noteIcon && <img src={noteIcon} className="step-note-icon" alt="no image" />}
            {stepNum && <span className="step-num">{stepNum}.</span>}
          </div>
          <div className="step-wavy-arrow">
            {wavyArrow && <img src={wavyArrow} alt="" />}
          </div>
        </div>
      </div>
      <div className="step-desc">
        <h4 className="heading-4" style={{color: "#FFF"}}>{heading}</h4>
        <p className="mb-0">{description}</p>
      </div>
    </div>
  );
};
